import { render } from "./Modificar.vue?vue&type=template&id=6e2b6b66&scoped=true"
import script from "./Modificar.vue?vue&type=script&lang=js"
export * from "./Modificar.vue?vue&type=script&lang=js"

import "./Modificar.vue?vue&type=style&index=0&id=6e2b6b66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2b6b66"]])

export default __exports__